import React, { Component } from "react";
// get our fontawesome imports
import { faVolumeUp, faVolumeMute } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class VolumeButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      muted: false,
    };
  }

  musicFavicon() {
    if (this.props.muted) {
      return <FontAwesomeIcon icon={faVolumeMute} />;
    } else {
      return <FontAwesomeIcon icon={faVolumeUp} />;
    }
  }

  render() {
    const { icon } = this.state;
    return (
      <div
        className="position-fixed bg-white rounded-4"
        style={{ zIndex: 100, bottom: `0.5rem`, left: `0.5rem` }}
      >
        <button
          className="btn btn-outline-pink rounded-4"
          onClick={this.props.handleMute}
        >
          {this.musicFavicon()}
        </button>
      </div>
    );
  }
}

export default VolumeButton;
